import { MutationTree } from "vuex";
import { ForexBuyState } from "@/feature/Forex/store/buy/interface";
import { ForexBuyMutation } from "@/feature/Forex/store/buy/constants";
import { ForexBuyDraft } from "@/feature/Forex/api/form/forex-form.interface";
import { mapForexBuyCreatedDraft } from "@/feature/Forex/api/form/forex-form.utils";
import { ForexOperationType } from "@/feature/Forex/api/forex.interface";

export default <MutationTree<ForexBuyState>> {

	[ForexBuyMutation.setCurrentDraft](state, draft: ForexBuyDraft) {
		state.currentDraft = draft as Required<ForexBuyDraft>;
	},

	[ForexBuyMutation.updateCurrentDraft](state, draft: ForexBuyDraft) {
		Object.assign(state.currentDraft, draft as Required<ForexBuyDraft>);
	},

	[ForexBuyMutation.resetCurrentDraft](state) {
		state.currentDraft = mapForexBuyCreatedDraft();
		state.uploadFileRequests = {};
		state.preventNextRoute = true;
	},

	[ForexBuyMutation.setPreventNextRoute](state, preventNextRoute: boolean) {
		state.preventNextRoute = preventNextRoute;
	},

	[ForexBuyMutation.setOperationType](state, operationType: ForexOperationType) {
		state.operationType = operationType;
	},

	[ForexBuyMutation.setDraftIsSent](state, draftIsSent: boolean) {
		state.draftIsSent = draftIsSent;
	},

}